@if (selectedIndex == 0) {
  <div class="activity-booking">
    <div class="booking-group">
      <div class="row margin-neg">
        @if (bookingValue !== 0) {
          <div class="col-lg-3 col-md-4 filter-tab">
            <div class="txt-bold">
              {{'filterBy' | translate}}
            </div>
          </div>
        }
        <div class="col-lg-7 col-md-6">
          <div class="font-size-18px activity-title">
            {{'ActivityDetails' | translate}}
          </div>
          @if (activityService.operation === Operation.create) {
            <mat-radio-group aria-label="'SelectBookoingType' | translate" (change)="setBookingType($event)"
              >
              <mat-radio-button value="1" [checked]="bookingValue === ActivityBookingType.ClassBooking">
                {{'BookaLesson' | translate}}
              </mat-radio-button>
              <mat-radio-button value="0" [checked]="bookingValue === ActivityBookingType.OpenBooking">
                {{'ReserveaLocation' | translate}}
              </mat-radio-button>
              <mat-radio-button value="2" [checked]="bookingValue === ActivityBookingType.PrivateLesson">
                {{'PrivateLesson' | translate}}
              </mat-radio-button>
            </mat-radio-group>
          }
        </div>
      </div>
    </div>
    @if (bookingValue === ActivityBookingType.ClassBooking) {
      <div class="activity-selector">
        <app-activity-class-booking></app-activity-class-booking>
      </div>
    }
    @if (bookingValue === ActivityBookingType.OpenBooking) {
      <div class="activity-selector">
        <app-open-booking-selector></app-open-booking-selector>
      </div>
    }
    @if (bookingValue === ActivityBookingType.PrivateLesson) {
      <div class="activity-selector">
        <app-activity-class-booking></app-activity-class-booking>
      </div>
    }
  </div>
}